export default "__VITE_ASSET__DHshpYpW__"